import { createHttpClient } from '../../api/http';
import { serviceUrls } from '../../config/serviceUrls';

// Prefer calling the gateway for browser-facing scenario definitions.
// Allow explicit direct ai-tutor testing only when VITE_USE_DIRECT_AI_TUTOR === "true".
const GATEWAY_BASE =
  import.meta.env.VITE_GATEWAY_API_BASE_URL ||
  import.meta.env.VITE_GATEWAY_URL ||
  import.meta.env.VITE_API_BASE_URL ||
  'http://localhost:8080';

const explicitDirect = (import.meta.env.VITE_AI_TUTOR_BASE_URL || '').trim();
const allowDirect = (import.meta.env.VITE_USE_DIRECT_AI_TUTOR || '').trim().toLowerCase() === 'true';
const TUTOR_BASE = allowDirect && explicitDirect ? explicitDirect : GATEWAY_BASE;
const client = createHttpClient(TUTOR_BASE);
const PREFIX = TUTOR_BASE.includes('ai-tutor') ? '/tutor' : '/v1/tutor';

export async function listScenarioDefinitions(): Promise<{ ok: boolean; items: Record<string, unknown>[] }> {
  const r = await client.get(`${PREFIX}/scenario/definitions`);
  return r.data as { ok: boolean; items: Record<string, unknown>[] };
}

export async function upsertScenarioDefinition(payload: Record<string, unknown>): Promise<unknown> {
  const r = await client.post(`${PREFIX}/scenario/definitions`, payload);
  return r.data;
}
